export const tagging = [
  {
    pageName: 'FWA_PlansOverview',
    throttle: [
      {
        key: 'signInPlacement',
        value: 'sign in',
      },
      {
        key: 'autopay-preview',
        value: 'AP Toggle Y',
      },
      {
        key: 'autopay-C-preview',
        value: 'AP Toggle N',
      },
    ],
  },
  {
    pageName: 'FWA_ShoppingCart',
    throttle: [
      {
        key: 'FWA_Cart_T_ContactInfo',
        value: 'cart info',
      },
      {
        key: 'FWA_Sweetener_T_Deal',
        value: 'sweetener y',
      },
      {
        key: 'FWA_Sweetener_C_Deal',
        value: 'sweetener n',
      },
      {
        key: 'FWA_Sweetener_T_Deal_P',
        value: 'sweetener y',
      },
      {
        key: 'FWA_Sweetener_C_Deal_P',
        value: 'sweetener n',
      },
      {
        key: 'FWA_P_Sweetener_T_Deal',
        value: 'sweetener y',
      },
      {
        key: 'FWA_P_Sweetener_C_Deal',
        value: 'sweetener n',
      },
      {
        key: 'FWA_Sweetener_Deal_wl',
        value: 'sweetener y',
      },
    ],
  },
  {
    pageName: 'FWA_ContactInfo',
    throttle: [],
  },
  {
    pageName: 'FWA_Shipping',
    throttle: [
      {
        key: 'FWA_T_ServiceAddressDisplay',
        value: 'service address y',
      },
      {
        key: 'FWA_Express_T_Pickup',
        value: 'ep y',
      },
      {
        key: 'FWA_Express_C_Pickup',
        value: 'ep n',
      },
    ],
  },
];
